import { useMemo } from 'react';
import ContainerFlex from '~/components/containerFlex';
import * as St from '../../styles';
import Input, { MaskTypes } from '~/components/input';
import Select from '~/components/select';
import {
  BASE_RESULT_FACES,
  BIOMETRICS_ORIGIN,
  RESULT_LIVENESS,
  BIOMETRIA_TYPE_OPTIONS,
  RESULTADO_AUTENTICACAO_UNICO,
  RESULTADO_ALERTA_COMPORTAMENTO_UNICO,
  RESULTS_BANKNOW,
  BIOMETRICS_ORIGIN_BANKNOW,
} from '../../models';
import Button from '~/components/button';
import { useFilterBiometrics } from '../../context/FilterBiometricContext';
import { BsSearch } from 'react-icons/bs';
import { useHistory, useLocation } from 'react-router-dom';

interface IFilterBiometrics {
  onClick?: (any: any) => void;
}

const FilterBiometrics: React.FC<IFilterBiometrics> = ({ onClick }) => {
  const { form, setForm } = useFilterBiometrics();

  const history = useHistory();

  const handleChange = ({
    target: { value, name },
  }: React.ChangeEvent<HTMLInputElement>) => {
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleClickForm = (el): void => {
    onClick?.(el);
  };

  const isButtonDisabled = useMemo(() => {
    return !(
      (form.cpf?.masked?.length === 14 && form.origem) ||
      (form.dataBiometriaInicial?.length === 10 &&
        form.dataBiometriaFinal?.length === 10)
    );
  }, [form]);

  const goToUnlockBiometrics = () => {
    history.push('/consult/user/unlock-biometrics');
  };

  return (
    <St.BoxCard>
      <ContainerFlex row space>
        <ContainerFlex marginRight={16} space gap="20">
          <Select
            label="Biometria"
            options={BIOMETRIA_TYPE_OPTIONS}
            name="biometriaType"
            value={form.biometriaType}
            onChange={(selectedOption) => {
              if (selectedOption === 'blocked') {
                goToUnlockBiometrics();
              } else {
                setForm((prev) => ({ ...prev, biometriaType: selectedOption }));
              }
            }}
          />
          <Input
            label="CPF"
            name="cpf"
            maxLength={14}
            placeholder="000.000.000-00"
            value={form.cpf?.masked}
            mask={MaskTypes.CPF}
            onChange={handleChange}
          />
        </ContainerFlex>
        <ContainerFlex marginRight={16} space gap="20">
          <Input
            label="De"
            placeholder="DD/MM/YYYY"
            name="dataBiometriaInicial"
            maxLength={10}
            value={form.dataBiometriaInicial}
            onChange={(e) => {
              setForm({
                ...form,
                dataBiometriaInicial: e.target.value.masked,
              });
            }}
            mask={MaskTypes.DATE}
          />
          {form.biometriaType === 'banknow' && (
            <Select
              label="Retorno validações"
              options={RESULTS_BANKNOW}
              name="status"
              value={form.status}
              onChange={(selectedOption) => {
                setForm((prev) => ({ ...prev, status: selectedOption }));
              }}
            />
          )}
          {form.biometriaType === 'unico' && (
            <Select
              label="Resultado Autenticação"
              options={RESULTADO_AUTENTICACAO_UNICO}
              name="codigoAutenticacao"
              value={form.codigoAutenticacao}
              onChange={(selectedOption) => {
                setForm((prev) => ({
                  ...prev,
                  codigoAutenticacao: selectedOption,
                }));
              }}
            />
          )}
        </ContainerFlex>

        {form.biometriaType === 'unico' && (
          <>
            <ContainerFlex marginRight={16} space gap="20">
              <Input
                label="Até"
                placeholder="DD/MM/YYYY"
                maxLength={10}
                value={form.dataBiometriaFinal}
                onChange={(e) => {
                  setForm({
                    ...form,
                    dataBiometriaFinal: e.target.value.masked,
                  });
                }}
                mask={MaskTypes.DATE}
              />
              <Select
                label="Resultado Alerta Comportamento"
                options={RESULTADO_ALERTA_COMPORTAMENTO_UNICO}
                name="codigoComportamento"
                value={form.codigoComportamento}
                onChange={(selectedOption) => {
                  setForm((prev) => ({
                    ...prev,
                    codigoComportamento: selectedOption,
                  }));
                }}
              />
            </ContainerFlex>
          </>
        )}
        {form.biometriaType === 'banknow' && (
          <>
            <ContainerFlex marginRight={16} space gap="20">
              <Input
                label="Até"
                placeholder="DD/MM/YYYY"
                maxLength={10}
                value={form.dataBiometriaFinal}
                onChange={(e) => {
                  setForm({
                    ...form,
                    dataBiometriaFinal: e.target.value.masked,
                  });
                }}
                mask={MaskTypes.DATE}
              />
            </ContainerFlex>

            <ContainerFlex marginRight={16} space gap="20">
              <Select
                label="Origem"
                options={BIOMETRICS_ORIGIN_BANKNOW}
                name="origem"
                value={form.origem}
                onChange={(selectedOption) => {
                  setForm((prev) => ({ ...prev, origem: selectedOption }));
                }}
              />
            </ContainerFlex>
          </>
        )}

        <ContainerFlex>
          <ContainerFlex row gap="10" marginTop={24}>
            <Button
              onClick={() => handleClickForm(form)}
              disabled={isButtonDisabled}
              style={{ display: 'inline-flex', gap: 8 }}
            >
              <BsSearch style={{ marginRight: 4 }} />
              <span>Consultar</span>
            </Button>
          </ContainerFlex>
        </ContainerFlex>
      </ContainerFlex>
    </St.BoxCard>
  );
};

export default FilterBiometrics;
